<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  async mounted() {
    const loading = this.$buefy.loading.open();
    try {
      await Promise.all([
        this.$store.dispatch('fetchCompany'),
        this.$store.dispatch('fetchContact'),
      ]);
    } finally {
      loading.close();
    }
  },
};
</script>

<style lang="scss">
@import '@/assets/scss/font.scss';
@import '~bulma/sass/utilities/initial-variables.sass';
@import '@/assets/scss/variables.scss';

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

$carousel-arrow-color: $grey;
$carousel-indicator-border: $white;
$carousel-indicator-color: $white;
$carousel-indicator-border: $grey;

@import '~bulma/sass/utilities/_all';
@import '~bulma';
@import '~buefy/src/scss/buefy';
</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
